const unsupportedNode = require('./helper').unsupportedNode;

module.exports = unsupportedNode('Call activities not supported by execution engine','bpmn:CallActivity');
